import React from "react"

export default function Header() {

    return (
       <header>
            <div className="header-flex"> 
                <div>
                    <a className="logo" href="/">NV</a>
                </div>
                <div>
                    <a className="download-link-header" href="/partner"><span className="header-download">Invest / Partner</span></a>
                </div>
            </div>
        </header>
    )
}

